
import { App} from '@capacitor/app';
import 'babel-polyfill'
import Vue from "vue";
import "./plugins/axios";
import viewApp from "./App.vue";
import router from "./router";
import store from "./store";
import VueDayjs from 'vue-dayjs-plugin'

import { ToggleButton } from 'vue-js-toggle-button'

Vue.component('ToggleButton', ToggleButton)

Vue.config.productionTip = false;

Vue.use(VueDayjs)
new Vue({
  router,
  store,
  render: (h) => h(viewApp),
}).$mount("#app");


App.addListener('appUrlOpen', function (event) {
  const slug = event.url.split('.com').pop();
  setTimeout(()=>{
    if (slug) {
      router.push({
        path: slug,
      });
    }
  },1000)
});
